import { render, staticRenderFns } from "./expand-control.vue?vue&type=template&id=1427dc4c&scoped=true"
import script from "./expand-control.vue?vue&type=script&lang=ts"
export * from "./expand-control.vue?vue&type=script&lang=ts"
import style0 from "./expand-control.vue?vue&type=style&index=0&id=1427dc4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1427dc4c",
  null
  
)

export default component.exports